import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteContaListarRoutingModule } from './central-cliente-conta-listar-routing.module';
import { CentralClienteContaListarComponent } from './central-cliente-conta-listar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    CentralClienteContaListarComponent
  ],
  imports: [
    CommonModule,
    CentralClienteContaListarRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DividerModule,
    MessagesModule,
    CalendarModule,
    TooltipModule,
    ProgressSpinnerModule
  ]
})
export class CentralClienteContaListarModule { }
